import { render, staticRenderFns } from "./GesDocumento.vue?vue&type=template&id=0c175325&scoped=true&"
import script from "./GesDocumento.vue?vue&type=script&lang=js&"
export * from "./GesDocumento.vue?vue&type=script&lang=js&"
import style0 from "./GesDocumento.vue?vue&type=style&index=0&id=0c175325&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c175325",
  null
  
)

export default component.exports